import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import * as React from 'react'

interface Props {
  title: string
}

const CardEngineInfo: React.FC<React.PropsWithChildren<Props>> = ({ title, children }) => {
  return (
    <Accordion elevation={0} sx={{ mb: 1, borderRadius: 1 }}>
      <AccordionSummary
        aria-controls='panel1a-content'
        expandIcon={
          <ExpandMoreIcon sx={{ backgroundColor: 'red', borderRadius: '50%', color: '#fff' }} />
        }
        id='panel1a-header'
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ background: '#D6E4E5' }}>{children}</AccordionDetails>
    </Accordion>
  )
}

export default CardEngineInfo
